import { t } from 'i18next';

import { EmergencyIcon } from 'assets/svg';
import {
  TeamingReason,
  TeamingType,
} from 'features/teaming/teaming-base/enums';
import theme from 'features/theme/theme';

/* Functions use in this case because 't' function from 'i18next' works only with this solution */
export const getTeamingBaseReasonOptions = () => ({
  languageComprehension: {
    text: t('teamingReason.languageComprehension'),
    value: TeamingReason.SpokenLanguage,
  },
  unfamiliarContent: {
    text: t('teamingReason.unfamiliarContent'),
    value: TeamingReason.SpecializedContent,
  },
  conferenceCall: {
    text: t('teamingReason.conferenceCall'),
    value: TeamingReason.ConferenceCall,
  },
  emergency: {
    text: t('teamingReason.emergency'),
    value: TeamingReason.Emergency,
    customIcon: <EmergencyIcon />,
    customColor: theme.palette.emergency.text,
  },
});

export const getTeamingRemoteLocationOptions = () => ({
  remoteAnyVi: {
    text: t('teamRequest.remoteAnyVi'),
    value: TeamingType.RemoteAnyRequest,
    isDefault: true,
  },
  remoteInCenterVi: {
    text: t('teamRequest.remoteInCenterVi'),
    value: TeamingType.RemoteInCenterRequest,
  },
});

export const getTeamingInCenterLocationOptions = () => ({
  inCenterAnyVi: {
    text: t('teamRequest.inCenterAnyVi'),
    value: TeamingType.InCenterAnyRequest,
  },
  inCenterPreferredVi: {
    text: t('teamRequest.inCenterPreferredVi'),
    value: TeamingType.InCenterPreferredRequest,
  },
});

export const getTeamingReasonText = (reason: TeamingReason) => {
  const teamingReasonsTranslateMap: Partial<Record<TeamingReason, string>> = {
    [TeamingReason.Asl]: 'teamingReason.languageComprehension',
    [TeamingReason.SpecializedContent]: 'teamingReason.unfamiliarContent',
    [TeamingReason.ConferenceCall]: 'teamingReason.conferenceCall',
    [TeamingReason.Emergency]: 'teamingReason.emergency',
    [TeamingReason.SpokenLanguage]: 'teamingReason.languageComprehension',
  };
  const reasonKey = teamingReasonsTranslateMap[reason];

  return reasonKey ? t(reasonKey) : '';
};

/**
 * Parses the member-count from a DHVIConferenceChange SIP INFO message body.
 * @param body The SIP INFO message body
 * @returns The member count as a number, or null if not found/invalid
 */
export function parseConferenceMemberCount(body: string): number | null {
  const match = /member-count="(\d+)"/.exec(body);
  if (match) {
    return Number.parseInt(match[1], 10);
  }
  return null;
}
